<template >
    <el-drawer
            :visible.sync="show"
            :close-on-click-modal="false"
            custom-class="detail-info-dia-historyDrawer"
            size="815px"
    >
        <div class="scroll-wrap">
            <vue-scroll :ops="createScrollOpt(true)" ref="vScroll">
                <div class="stu-info-box">
                    <template v-if="loading">
                        <yioks-loading></yioks-loading>
                    </template>
                    <template v-if="!loading">
                        <div class="scrollArea">
                            <div class="tbodyWrap">
                                <template v-if="coachHistoryInfo.coachUser.coachLicenseNumber">
                                    <div class="licenseInfo">
                                        <h3 class="title">教练员执照</h3>
                                        <el-row class="score-row">
                                            <el-col :span="7"
                                                    class="score-col">
                                                <p>等级：{{coachHistoryInfo.coachUser.coachRankType | level}}</p>
                                            </el-col>
                                            <el-col :span="9"
                                                    class="score-col">
                                                <p>执照编号：{{coachHistoryInfo.coachUser.coachLicenseNumber||'--'}}</p>
                                            </el-col>
                                            <el-col :span="8"
                                                    class="score-col">
                                                <p>有效期至：{{coachHistoryInfo.coachUser.coachLicenseEnd ||'--'}}</p>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </template>
                                <template v-if="coachHistoryInfo.coachUser.continueCumulativeHoursCount">
                                    <div class="licenseInfo">
                                        <h3 class="title">继续教育学时汇总</h3>
                                        <el-row class="score-row">
                                            <el-col :span="7"
                                              class="score-col">
                                                <p>等级：{{coachHistoryInfo.coachUser.coachRankType | level}}</p>
                                            </el-col>
                                            <el-col :span="9"
                                              class="score-col">
                                                <p>已获得学时：{{coachHistoryInfo.coachUser.continueCumulativeHoursCount||'--'}} &nbsp;&nbsp;&nbsp;未完成学时：{{coachHistoryInfo.coachUser.coachRankType === 'C' ? 32 - coachHistoryInfo.coachUser.continueCumulativeHoursCount : 60 - coachHistoryInfo.coachUser.continueCumulativeHoursCount}}</p>
                                            </el-col>
                                            <el-col :span="8"
                                              class="score-col">
                                                <p>学时有效期至：{{coachHistoryInfo.coachUser.continueCreateDate | continueEndDate}}</p>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </template>
                                <template v-if="list.length > 0">
                                    <h3 class="c_title">教练员培训历程</h3>
                                </template>
                                <div class="tbody"  v-if="list.length > 0">
                                    <div class="tr" v-for="(item, index) in list" :key="index">
                                        <div class="rankInfo" >
                                            <el-row class="score-row">
                                                <el-col :span="12"
                                                        class="score-col">
                                                    <p>等级：{{item.coachRankType | level}} （{{item.createCoachRank === 5 ? '继续教育' : '等级培训'}}）</p>
                                                </el-col>
                                                <el-col :span="12"
                                                        class="score-col">
                                                    <p>通过状态：{{item.coachRankStatus=='有效'?'通过':item.coachRankStatus}}</p>
                                                </el-col>
                                            </el-row>
                                            <el-row class="score-row">
                                                <el-col :span="12"
                                                        class="score-col">
                                                    <p>所属年份：{{item.coachRankYear}}年</p>
                                                </el-col>
                                                <el-col :span="12"
                                                        class="score-col">
                                                    <p>讲师：{{item.lecturerName || "--"}}</p>
                                                </el-col>
                                            </el-row>
                                            <el-row class="score-row">
                                                <el-col :span="12"
                                                        class="score-col">
                                                    <p>举办方：{{item.coachRankOrgan || "--"}}</p>
                                                </el-col>
                                                <el-col :span="12"
                                                        class="score-col">
                                                    <p>培训地点：{{item.classAddress || "--"}}</p>
                                                </el-col>
                                            </el-row>
                                            <el-row class="score-row">
                                                <el-col :span="12"
                                                        class="score-col">
                                                    <p>培训开始时间：{{item.classStart || "--"}}</p>
                                                </el-col>
                                                <el-col :span="12"
                                                        class="score-col">
                                                    <p>培训结束时间：{{item.classEnd || "--"}}</p>
                                                </el-col>
                                            </el-row>
                                            <el-row class="score-row" v-if="item.coachRankStatus=='有效' && item.createCoachRank !== 5">
                                                <el-col :span="12"
                                                        class="score-col">
                                                    <p>证书编号：{{item.certificateNum || "--"}}<span v-if="item.certificateUrl" style="cursor:pointer;color: #4cd964" ><a
                                                            target="_blank"   :href="item.certificateUrl">（查看电子证书）</a></span></p>
                                                </el-col>
                                                <el-col :span="12"
                                                        class="score-col">
                                                    <p>编号时间：{{item.certificateDate || "--"}}</p>
                                                </el-col>
                                            </el-row>
                                            <el-row class="score-row" v-if="item.createCoachRank === 5">
                                                <el-col :span="12"
                                                  class="score-col">
                                                    <p>获得学时：{{item.coachRankStatus=='有效' ? item.continueCumulativeHours : 0}}</p>
                                                </el-col>
                                            </el-row>
                                            <el-row class="score-row" v-if="item.score ">
                                                <div class="score-table" >
                                                    <div class="row">
                                                        <div class="score-col"
                                                             v-for="item_score in item.score">
                                                            <p>{{ item_score.achievementSubjectTitle  }}</p>
                                                            <p >{{item_score.achievementScore}}
                                                                <span v-if="Number(item_score.achievementScore)">分</span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </el-row>
                                            <template v-if="item.createCoachRank===3">
                                                <el-row class="score-row bz" v-if="item.coachRankStatus==='有效'">
                                                    <el-col :span="24" class="score-col">
                                                        <p>2008年12月31日之前参加岗位培训的足球教练员不颁发电子证书，无需提交缺失资质审核。详细内容请参见<span style="color: #4cd964"><a
                                                                href="http://www.thecfa.cn/hitz/20190909/27995.html" target="_blank">《中国足协关于发放亚足联/中国足协教练员等级证书和执照的通知》</a></span> </p>
                                                    </el-col>
                                                </el-row>
                                            </template>
                                            <template v-else-if="item.createCoachRank===5">
                                                <el-row class="score-row bz" v-if="item.coachRankStatus==='有效'">
                                                    <el-col :span="24" class="score-col">
                                                        <p>C级继续教育需要完成32小时的课程学习，职业级/A级/B级继续教育需要完成60小时的课程学习，学时达到以后会自动更新执照有效期。</p>
                                                    </el-col>
                                                </el-row>
                                            </template>
                                            <template v-else-if="item.createCoachRank===4">
                                                <el-row class="score-row bz" v-if="item.coachRankStatus==='有效'">
                                                    <el-col :span="24" class="score-col">
                                                        <p>中国籍教练员在国外获得的教练员等级证书或在国内参加国外驻华或来华机构举办的教练员培训班获得的等级证书，通过中国足协认证后仅颁发新的执教执照，不再颁发新的电子证书，无需提交缺失资质审核。</p>
                                                    </el-col>
                                                </el-row>
                                            </template>
                                            <template v-else>
                                                <el-row class="score-row bz" v-if=" item.coachRankStatus==='有效' && item.coachRankType==='D' && Number(item.coachRankYear) < 2019">
                                                    <el-col :span="24"
                                                            class="score-col">
                                                        <p>2018年12月31日之前参加培训的D级教练员不颁发电子证书，无需提交缺失资质审核。详细内容请参见<span style="color: #4cd964"><a
                                                                href="http://www.thecfa.cn/hitz/20190909/27995.html" target="_blank">《中国足协关于发放亚足联/中国足协教练员等级证书和执照的通知》</a></span> </p>
                                                    </el-col>
                                                </el-row>
                                                <el-row class="score-row bz" v-else-if="item.certificateNum && !item.certificateUrl" >
                                                    <el-col :span="24"
                                                            class="score-col">
                                                        <p>电子证书信息正在审核中，审核通过后将会短信通知。</p>
                                                    </el-col>
                                                </el-row>
                                            </template>
                                            <div v-if="index !== list.length - 1" class="dashed-line"></div>
                                        </div>
                                    </div>
                                </div>
                                <template v-if="list.length===0">
                                    <yioks-empty></yioks-empty>
                                </template>
                            </div>
                        </div>
                    </template>
                </div>
            </vue-scroll>
        </div>
    </el-drawer>
</template>

<script>
    import createScrollOpt from "@/assets/js/vuescrollOption";
    import { LevelFilters } from "@/assets/js/status";
    export default {
        name: "history",
        props:{
            list:{
                type:Array,
                required:true
            },
            coachHistoryInfo:{
                type:Object,
                required: true,
            },
            showHistory:{
                type:Boolean,
                default:false,
            },
            loading:{
                type:Boolean,
                default: false
            }
        },
        components:{
            "yioks-loading": () => import("@/components/Loading/Loading"),
            "yioks-empty": () => import("@/components/Tips/Empty-grey"),
        },
        computed:{
            show:{
                get(){
                    return this.showHistory
                },
                set(val){
                    this.$emit('update:showHistory',val)
                }
            }
        },
        data(){
            return{
                createScrollOpt,
            }
        },
        filters:{
            level(level){
                if (!level){
                    return '--'
                }
                return LevelFilters(level)
            },
          continueEndDate(dateText){
            let date=new Date(dateText);
            date.setFullYear(date.getFullYear()+3);
            date.setDate(date.getDate()-1);
            return date.getFullYear() + '-12-31'
          },
        }
    }
</script>

<style lang="stylus">
    .detail-info-dia-historyDrawer
        height 100%
        .scroll-wrap
            display block
            height 900px
            overflow hidden
            position relative
            .stu-info-box
                display block
                padding 0 15px
                font-size 14px
                .scrollArea {
                    width: 100%;
                    height: 100%;
                    .tbodyWrap {
                        padding: 0 10px 0 0;
                        .c_title{
                            display block
                            font-weight bolder
                            font-size 18px
                            line-height 1
                            padding-bottom 8px
                            border-bottom 1px solid #ccc
                            margin-bottom 10px
                            p{
                                font-size 16px
                                align-self: flex-end;
                                margin-left: 5px;
                            }
                        }
                        .licenseInfo{
                            margin-bottom 15px
                            .title{
                                display block
                                font-weight bolder
                                font-size 18px
                                line-height 1
                                padding-bottom 8px
                                border-bottom 1px solid #ccc
                                margin-bottom 10px
                                p{
                                    font-size 16px
                                    align-self: flex-end;
                                    margin-left: 5px;
                                }
                            }
                            .score-row {
                                border: 1px solid #606266;
                                .score-col {
                                    text-align: center;
                                    border-left: 1px solid #606266;
                                    &:first-child {
                                        border-left: none;
                                    }
                                    p {
                                        margin: 10px ;
                                        font-size: 14px;
                                        word-break: break-all;
                                        &.score-note {
                                            text-align: left;
                                        }
                                    }
                                }
                            }
                        }

                        .tbody {
                            .rankInfo {
                                width: 100%;
                                position: relative;
                                margin-bottom 20px
                                border: 1px solid #606266;
                                .score-row {
                                    border-bottom: 1px solid #606266;
                                    .score-table {
                                        .row {
                                            border-bottom: 1px solid #606266;
                                            display:flex;
                                            &:last-child {
                                                border-bottom: none;
                                            }
                                            .score-col {
                                                text-align: center;
                                                border-left: 1px solid #606266;
                                                flex:auto;
                                                &:first-child {
                                                    border-left: none;
                                                }
                                                p {
                                                    margin: 10px 0;
                                                    font-size: 14px;
                                                    word-break: break-all;
                                                    &.score-note {
                                                        text-align: left;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    &:last-child {
                                        border-bottom: none;
                                    }
                                    .score-col {
                                        text-align: center;
                                        border-left: 1px solid #606266;
                                        &:first-child {
                                            border-left: none;
                                        }
                                        p {
                                            margin: 10px;
                                            font-size: 14px;
                                            word-break: break-all;
                                            &.score-note {
                                                text-align: left;
                                            }
                                        }
                                    }
                                }
                                .bz{
                                    .score-col{
                                        text-align left
                                    }
                                }
                                .dashed-line {
                                    width: 100%;
                                    position: absolute;
                                    bottom: -18px;
                                    left: 0;
                                    border: 1px dashed #606266;
                                }

                            }
                            .rankInfo:last-of-type{
                                margin-bottom 18px
                            }
                            .tr {
                                display: flex;
                                margin: 0 0 15px;
                                &:last-child{
                                    margin 0
                                }
                                .detail {
                                    flex: 1 1 auto;
                                    padding: 10px;
                                    border: 1px solid #606266;
                                    .title {
                                        font-size: 20px;
                                    }
                                }
                            }
                        }
                    }
                }

</style>
<style lang="stylus">
    .detail-info-dia-historyDrawer{
        position: absolute;
        box-sizing: border-box;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        box-shadow: 0 8px 10px -5px rgba(0,0,0,.2), 0 16px 24px 2px rgba(0,0,0,.14), 0 6px 30px 5px rgba(0,0,0,.12);
        overflow: hidden;
        right 0
        height 100%
        animation:mymove 5s infinite;
        animation-timing-function:linear;
        .el-drawer__header {
            align-items: center;
            justify-content space-between
            color: #72767b;
            display: flex;
            padding: 20px 20px 0 20px;
            .el-drawer__close-btn {
                border: none;
                cursor: pointer;
                font-size: 20px;
                color: inherit;
                background-color: transparent;
            }
        }
    }
</style>
<style lang="stylus" scoped>
    @media screen and (max-height: 900px) {
        .scroll-wrap{
            height 630px
        }
    }
</style>
